(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    !window.Theme.settings.enable_cart_redirection && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', (event) => {
    // Update cart count in header (adapted from Product.js updateCart function)
    window.Shopify.getCart(cart => {
      const cartAmountWrap = document.querySelector('[data-header-cart-count]');
      if (cartAmountWrap) {
        cartAmountWrap.innerHTML = `(${cart.item_count})`;
      }
    });
  });

  document.addEventListener('product-form:cart:update', (event) => {
    // Update cart count when cart state changes (using cart data from event)
    const cartAmountWrap = document.querySelector('[data-header-cart-count]');
    if (cartAmountWrap && event.detail.cart) {
      cartAmountWrap.innerHTML = `(${event.detail.cart.item_count})`;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
